function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15376_421301)"
}, React.createElement("rect", {
  x: 4.5,
  y: 4,
  width: 20,
  height: 20,
  rx: 10,
  fill: "#0F0B6A"
}), React.createElement("path", {
  d: "M11.493 9.4996C12.3824 8.90503 13.4203 8.59078 14.4945 8.59078C15.5695 8.59078 16.608 8.90546 17.4979 9.50074L17.898 9.76851L21.1549 6.51171L20.6308 6.10388C18.8621 4.72736 16.7402 3.99976 14.4945 3.99976C12.2499 3.99976 10.1286 4.72681 8.36023 6.10235L7.83594 6.51011L11.0929 9.76707L11.493 9.4996Z",
  fill: "#FF959F"
}), React.createElement("path", {
  d: "M22.3952 7.86535L21.9874 7.34106L18.7305 10.598L18.9979 10.9981C19.5925 11.8875 19.9067 12.9255 19.9067 13.9997C19.9067 15.0738 19.5925 16.1117 18.9979 17.0011L18.7305 17.4013L21.9874 20.6582L22.3952 20.1339C23.7707 18.3655 24.4977 16.2442 24.4977 13.9996C24.4977 11.755 23.7707 9.63376 22.3952 7.86535Z",
  fill: "#6E67D6"
}), React.createElement("path", {
  d: "M17.4979 18.4987C16.608 19.094 15.5695 19.4087 14.4945 19.4087C13.4203 19.4087 12.3824 19.0944 11.493 18.4999L11.0929 18.2324L7.83594 21.4893L8.36023 21.8971C10.1286 23.2727 12.2499 23.9997 14.4946 23.9997C16.7402 23.9997 18.8621 23.2721 20.6309 21.8956L21.155 21.4878L17.8981 18.231L17.4979 18.4987Z",
  fill: "#93E87F"
}), React.createElement("path", {
  d: "M9.99712 17.0031C9.4018 16.1133 9.08715 15.0748 9.08715 13.9998C9.08715 12.9248 9.40184 11.8862 9.99712 10.9964L10.2649 10.5962L7.00801 7.33936L6.60017 7.86341C5.22366 9.63221 4.49609 11.7542 4.49609 13.9998C4.49609 16.2454 5.22366 18.3673 6.60017 20.1361L7.00801 20.6602L10.2649 17.4033L9.99712 17.0031Z",
  fill: "#45E8FF"
}), React.createElement("path", {
  d: "M15.2322 13.3719H14.0562C13.8124 13.3719 13.6141 13.1736 13.6141 12.9298C13.6141 12.686 13.8124 12.4878 14.0562 12.4878H16.0417V11.315H15.0865V10.5244H13.9137V11.3212C13.0898 11.3936 12.4414 12.0874 12.4414 12.9298C12.4414 13.8201 13.1658 14.5445 14.0562 14.5445H15.2322C15.4989 14.5445 15.7158 14.7615 15.7158 15.0282C15.7158 15.2949 15.4989 15.5118 15.2322 15.5118H12.698V16.6846H13.9138V17.4752H15.0865V16.6846H15.2322C16.1456 16.6846 16.8886 15.9415 16.8886 15.0282C16.8886 14.1149 16.1455 13.3719 15.2322 13.3719Z",
  fill: "#FFDE55"
}), React.createElement("path", {
  d: "M17.8975 9.76847L21.1544 6.51167L20.6303 6.10384C18.8621 4.72775 16.7409 4.00019 14.4961 3.99976V8.59074C15.5703 8.59113 16.6081 8.90581 17.4973 9.5007L17.8975 9.76847Z",
  fill: "#FF598B"
}), React.createElement("path", {
  d: "M17.4973 18.4987C16.608 19.0936 15.5703 19.4083 14.4961 19.4087V23.9997C16.7409 23.9992 18.862 23.2717 20.6303 21.8956L21.1544 21.4878L17.8975 18.231L17.4973 18.4987Z",
  fill: "#00CC76"
}), React.createElement("path", {
  d: "M16.0377 12.4877V11.315H15.0825V10.5244H14.4961V12.4877H16.0377Z",
  fill: "#FFDE55"
}), React.createElement("path", {
  d: "M15.0825 16.6846H15.2282C16.1415 16.6846 16.8846 15.9415 16.8846 15.0282C16.8846 14.1149 16.1415 13.3718 15.2282 13.3718H14.4961V14.5446H15.2282C15.4949 14.5446 15.7118 14.7615 15.7118 15.0282C15.7118 15.2949 15.4949 15.5118 15.2282 15.5118H14.4961V17.4752H15.0825V16.6846Z",
  fill: "#FFDE55"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_15376_421301"
}, React.createElement("rect", {
  x: 4.5,
  y: 4,
  width: 20,
  height: 20,
  rx: 10,
  fill: "white"
})));

var SvgTaisanActive = function SvgTaisanActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTaisanActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/taisan_active.eb6c5879.svg";
export { ForwardRef as ReactComponent };